module.exports = __webpack_public_path__ + "static/media/fireengine.2a26ade9.png";